import {
  SocialMediaLinks,
  TARTICLE_PROPS,
  TBreadcrumbTransform,
  TGlossary_Card,
} from '../../glossary/utils/types';
import { keywordArray } from './contants';

export const tranformBreadcrumb = (
  articleData: TARTICLE_PROPS
): TBreadcrumbTransform[] => {
  const dataSet = articleData?.breadcrumbs.map((item, index) => {
    if (index === articleData?.breadcrumbs.length - 1) {
      return {
        title: item.term,
        link: null,
      };
    }
    return {
      title: item.term,
      link: `/glossary/${item.SEO_term}`,
    };
  });
  const result = [{ title: 'Home', link: '/glossary' }, ...dataSet];
  return result;
};

export const convertToTitleCase = (str: string): string => {
  const words = str.split('-');

  const titleCaseStr = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return titleCaseStr;
};

export const transformBreadcrumbKeyword = (
  keyword: string
): TBreadcrumbTransform[] => {
  return [
    {
      title: 'Home',
      link: '/glossary',
    },
    {
      title: keyword?.toUpperCase(),
      link: null,
    },
  ];
};

export const socialIconLink = (slug: string, id: string): string => {
  const links: SocialMediaLinks = {
    whatsapp: `whatsapp://send/?text=https://cleartax.in/g/terms/${slug}?ref=whatsapp-share1`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=https://cleartax.in/g/terms/${slug}?ref=facebook-share`,
    twitter: `https://twitter.com/share?url=https://cleartax.in/g/terms/${slug}?ref=twitter-share`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=https://cleartax.in/g/terms/${slug}?ref=linkedin-share`,
  };
  return links[id] || '#';
};

export const formateDate = (date: string): string => {
  const lmd = new Date(date);
  const formatedDate = lmd.toLocaleString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return formatedDate;
};

export const IndexPathGenSlug = () => {
  const paths: { params: { slug: [string, string] } }[] = [];
  keywordArray.forEach((item) => {
    paths.push({
      params: {
        slug: [item.toLocaleLowerCase(), 'index'],
      },
    });
  });
  return paths;
};

export const transposeResponse = (reponse: []) => {
  const result: { [key: string]: TGlossary_Card[] } = {};

  reponse?.map((eachCategory: { data: []; category: string }) => {
    result[eachCategory?.category] = [];

    eachCategory?.data?.forEach(
      (item: {
        title: string;
        permalink: string;
        updated_at: string;
        content: string;
      }) => {
        result[eachCategory.category] &&
          result[eachCategory.category]?.push({
            H1_1: item.title,
            Markdown: item.content.replace(/<[^>]*>/g, ''),
            SEO_term: item.permalink,
            hit_count: 1,
            interval_hit_count: 1,
            past_cycle_hits: 1,
            prev_hit_count: 1,
            updated_at: item.updated_at,
          });
      }
    );
  });

  return result;
};
